import React, {useEffect, useState} from 'react';
import './BottomSheet.scss';
import CloseIcon from '@rsuite/icons/Close';
import Buttons from "../../../buttons/buttons";
import Texts from "../../../texts/texts";
import DetectPlatformService from "../../../../services/detectPlatform";

const BottomSheet = (props) => {
    const {bottomSheetConfig} = props;
    const {title} = bottomSheetConfig;
    const {dismissible} = bottomSheetConfig;
    let {styles} = bottomSheetConfig;
    const {buttons} = bottomSheetConfig;
    const {texts} = bottomSheetConfig;
    const {opened} = bottomSheetConfig;
    const [status, setStatus] = useState(props.opened);
    const [platform, setPlatform] = useState('unknown');

    useEffect(()=>{
        const platform=  DetectPlatformService;
        setPlatform(platform);
    },[])

    return (<>
            <div className={`bottom-sheet-overlay ${opened ? 'opened' : ''}`}
                 onClick={e => opened ? dismiss() : false}></div>
            <div className={`bottom-sheet os-${platform}-bottom-sheet ${opened ? 'opened' : ''}`} style={styles ? styles : {}}>
                {title ? <div className="bs-title">{title}</div> : ''}
                {dismissible ? <div className="bs-dismiss" onClick={dismiss}><CloseIcon/></div> : ''}
                {title ? <div className='bs-line-container'>
                    <div className="bs-line"></div>
                </div> : ''}

                <div className="bs-body">
                    {texts ? <div className="bs-texts"><Texts texts={texts}/></div> : ''}
                    <div className="bs-buttons">
                        {buttons ? <Buttons buttons={buttons}/> : ''}
                    </div>
                </div>
            </div>
        </>
    );

    function dismiss() {
        let config = {...bottomSheetConfig};
        config.opened = false;
        props.bottomSheetHandler(config);

        return true;
    }
}

export default BottomSheet;